import { useTranslation } from "react-i18next";
import {
  useCreateTransferActivity,
  useGetTransferActivity,
  getTransferActivity,
} from "@packages/api/madlenAPI";
import {
  TransferActivityResponseDto,
  TransferActivityCreateRequestDto,
} from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import { TransferActivityCard } from "../../../components/transfer-activity/TransferActivityCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import { Text } from "@core/index";
import { CheckCircle } from "lucide-react";

const CreateTransferActivityView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("transferActivities.form.generateButton")}
      backPath="/content/transfer-activity"
      themeColor="terra"
      loadingTitle={t("transferActivities.form.loading")}
      errorTitle={t("transferActivities.result.error.title")}
      errorDescription={t("transferActivities.result.error.loadingError")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
      after={
        <div className="flex items-center space-x-2 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg">
          <CheckCircle className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          <Text variant="p" status="info" size="sm">
            {t("transferActivities.ubd")}
          </Text>
        </div>
      }
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: TransferActivityResponseDto;
    isImageLoading?: boolean;
    onCreateAgain: () => void;
  }) => {
    return (
      <TransferActivityCard
        transferActivity={toolData}
        isImageLoading={isImageLoading}
        onCreateAgain={onCreateAgain}
      />
    );
  };

  return (
    <GenericToolCreationPage
      toolType="transferActivities"
      useCreateTool={useCreateTransferActivity}
      useGetTool={useGetTransferActivity}
      getTool={getTransferActivity}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: TransferActivityResponseDto) => {
        if (!data) return null;

        if (
          !data.realLifeConnection ||
          !data.studentTask ||
          !data.teacherRole
        ) {
          return null;
        }
        return data;
      }}
    />
  );
};

export default CreateTransferActivityView;
